// src/store/interfaces/festival.state.ts
import { FestivalTheme } from '../../core/festival/festival.config';

export interface FestivalState {
  festivals:       FestivalTheme[];       // All festivals returned by API
  activeFestival:  FestivalTheme | null;  // The one currently applied
  bannerVisible:   boolean;
  loading:         boolean;
  error:           string | null;
  countryCode:     string | null;
}

export const initialFestivalState: FestivalState = {
  festivals:      [],
  activeFestival: null,
  bannerVisible:  false,
  loading:        false,
  error:          null,
  countryCode:    null,
};